import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import Form from "./Form";
import {UsePost, UsePut} from "../../hooks/http";
import {useNavigate} from "react-router-dom";
import {UseMessage} from "../../hooks/UseMessage";

const Create = () => {
    const navigate = useNavigate()
    const [errors, setErrors] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [permissions, setPermissions] = useState([])



    const handleCreate = (PostData) => {
        setIsLoading(true)
        UsePost(
            '/roles/upsert/',
            {data: PostData}
        ).then((response) => {
            window.setTimeout(() => {
                if(response.code >= 200 && response.code <= 299){
                    navigate(`/roles/${response.id}`)
                    UseMessage('success', 'Role has been successfully created')
                }else{
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }


    const GetPermissions = async () => {
        return await UsePut(
            `/permissions/get`,
            {data: {offset: 0}, toArray: true, propLabel: 'name'}
        )
    }
 

    useEffect(() => {
        GetPermissions().then((permissions) => {
            setPermissions(permissions)
            setIsLoading(false)
        })
    }, [])



    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form permissions={permissions} isReady={!isLoading} errors={errors} onSubmit={handleCreate} />
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Create